import Colors from "@constants/Colors";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";

export const FormHeaderBreadCrumb = ({ items }: { items: (string | { label: string, href: string })[] }) => {
    return (
        <Box display="flex" alignItems="center">
            {items.map((item, index) => (
                <Box key={index} display="flex" alignItems="center">
                    <Typography
                        sx={{
                            fontSize: {
                                xs: 12,
                                sm: 14,
                                md: 16,
                            },
                            color: index === items.length - 1 ? Colors.PRIMARY_PURPLE : Colors.NEUTRAL_PLACEHOLDER,
                            fontWeight: index === items.length - 1 ? 'bold' : 'normal',
                        }}
                        component={item instanceof Object ? Link : 'span'}
                        to={item instanceof Object ? item.href : '#'}
                    >
                        {item instanceof Object ? item.label : item}
                    </Typography>
                    {index < items.length - 1 && (
                        <Box mx={0.5} display="flex" alignItems="center">
                            <Box component="i" className="fi fi-rr-chevron-right" sx={{
                                fontSize: {
                                    xs: 12,
                                    sm: 14,
                                    md: 16,
                                }, color: Colors.NEUTRAL_PLACEHOLDER
                            }} />
                        </Box>
                    )}
                </Box>
            ))}
        </Box>
    );
};
